import { Colors } from '@sigma-frontend-libs/commons'
import { MODERATION_VALUES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, moderationColors, moderationIcons } from '@/utils'

import button from '@/components/button'
import { baseClass } from '@/components/rules/utils'

export default function(h) {
  return h(
    'div',
    {
      class: `${baseClass}-dialog__content-section--row`
    },
    MODERATION_VALUES.map(moderation => {
      const isSelected = this.proxy === moderation
      let mode = buttonModes.filled
      let color = moderationColors[moderation]
      if (!isSelected) {
        mode = buttonModes.flat
        color = Colors.description
      }

      return h(
        button,
        {
          props: {
            label: this.getTranslate(`misc.moderation.${moderation}`),
            icon: moderationIcons[moderation],
            mode,
            color
          },
          on: {
            click: () => {
              this.proxy = moderation
            }
          }
        }
      )
    })
  )
}

